const onlineReturns = () => {
	$(() => {
		$('.returnInformation, .exchangeInformation').hide();
		$('#tfa_2007').change(function () {
			var selected = $('#tfa_2007 option:selected').text();
			if (selected == 'Return') {
				$('.returnInformation').show();
			} else if (selected == 'Return & Exchange') {
				$('.returnInformation, .exchangeInformation').show();
			} else if (selected == 'Please select...') {
				$('.returnInformation, .exchangeInformation').hide();
			}
		});
	});
};

export default onlineReturns;
